import React from 'react';
import { MiniCheck, MiniNum } from './ControlPanelHelpers';

const DocTypesTab = ({ selectedDocTypes, setSelectedDocTypes, documentTypes, docTypeMinWords, setDocTypeMinWords }) => (
  <div data-testid="cp-doc-panel">
    <div style={{ fontSize: '0.5rem', color: '#555', marginBottom: 4 }}>DOCUMENT TYPES &middot; {selectedDocTypes.length}/{documentTypes.length} active</div>
    {documentTypes.map(dt => (
      <div key={dt.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0', borderBottom: '1px solid rgba(253, 230, 138,0.04)' }}>
        <MiniCheck checked={selectedDocTypes.includes(dt.id)} color={dt.color}
          onChange={() => setSelectedDocTypes(p => p.includes(dt.id) ? p.filter(d => d !== dt.id) : [...p, dt.id])}
          label={dt.name} />
        <MiniNum value={docTypeMinWords[dt.id] || 0}
          onChange={v => setDocTypeMinWords(p => ({ ...p, [dt.id]: v }))} />
      </div>
    ))}
  </div>
);

export default DocTypesTab;
